import c0 from './ability_test/answer_controller';
import c1 from './ability_test/ascertain_answer_controller';
import c2 from './ability_test/confirmation_button_controller';
import c3 from './ability_test/next_button_controller';
import c4 from './ability_test_controller';
import c5 from './additional_study_courses_form_controller';
import c6 from './admin/boards_controller';
import c7 from './admin/course_completion_test_corrections_correction_form_controller';
import c8 from './admin/informations_student_form_controller';
import c9 from './admin/media_completion_test_corrections_correction_form_controller';
import c10 from './admin/sc_schedules_index_controller';
import c11 from './admin/sc_schedules_show_controller';
import c12 from './admin/teaching_applications_controller';
import c13 from './admin/teachings/ability_test_companion_groups_form_controller';
import c14 from './admin/teachings/course_learning_pattern_form_controller';
import c15 from './admin/teachings/sections_edits/ability_test_questions_form_controller';
import c16 from './admin/teachings/sections_edits/ability_tests_form_controller';
import c17 from './admin/teachings/sections_edits/ascertain_tests_form_controller';
import c18 from './admin/teachings/sections_edits/media_completion_tests_form_controller';
import c19 from './admin/teachings/sections_edits/questionnaires_form_controller';
import c20 from './admin/teachings/sections_edits/report_question_form_controller';
import c21 from './admin/teachings/sections_edits_form_controller';
import c22 from './admin/teachings/sections_edits_form_name_setter_controller';
import c23 from './admin/teachings/settings/total_burden_rate_chargers_controller';
import c24 from './admin/teachings_controller';
import c25 from './admin/thesis_controller';
import c26 from './admin_boards_controller';
import c27 from './admin_users_controller';
import c28 from './anchor_link_controller';
import c29 from './ascertain_test/alternative_test_controller';
import c30 from './ascertain_test/complete_answer_test_controller';
import c31 from './ascertain_test/description_test_controller';
import c32 from './ascertain_test/no_particular_order_test_controller';
import c33 from './ascertain_test/self_assessment_test_controller';
import c34 from './ascertain_test/timer_controller';
import c35 from './assign_reports_controller';
import c36 from './assign_requests_controller';
import c37 from './authorings_controller';
import c38 from './auto_submit_controller';
import c39 from './auto_update_controller';
import c40 from './autosave_controller';
import c41 from './autosize_controller';
import c42 from './bulk_check_controller';
import c43 from './cache_height_controller';
import c44 from './certificate_application_summary_controller';
import c45 from './change_check_condition_controller';
import c46 from './change_questions_controller';
import c47 from './character_count_for_one_editor_controller';
import c48 from './checkboxes_controller';
import c49 from './combined_purchase_applications_controller';
import c50 from './combined_school_course_completion_test_applications_controller';
import c51 from './combined_schools/additional_studying_application_controller';
import c52 from './combined_schools/certificate_application_controller';
import c53 from './combined_schools/certificate_application_summary_controller';
import c54 from './combined_schools/certificate_applications_certificate_type_controller';
import c55 from './combined_schools/certificate_type_of_student_card_controller';
import c56 from './combined_schools/certificate_types_selection_controller';
import c57 from './combined_schools/english_name_controller';
import c58 from './combined_schools/reason_kind_controller';
import c59 from './combined_schools/school_register_renewal_application_controller';
import c60 from './combined_schools/teacher/extra_curricular_applications_course_form_controller';
import c61 from './combined_schools/teacher/media_teaching_applications_course_form_controller';
import c62 from './combined_schools/teacher/report_submissions_form_controller';
import c63 from './combined_schools/teacher/schooling_applications_course_form_controller';
import c64 from './commentary_modal_controller';
import c65 from './confirm_controller';
import c66 from './course_completion_test_corrections_controller';
import c67 from './course_completion_test_corrections_list_item_form_controller';
import c68 from './course_completion_test_waiting_timer_controller';
import c69 from './course_informations_controller';
import c70 from './current_time_controller';
import c71 from './demo/report_file_input_controller';
import c72 from './demo/report_form_controller';
import c73 from './demo/test_answer_form_controller';
import c74 from './display_student_info_controller';
import c75 from './display_teaching_info_controller';
import c76 from './document_controller';
import c77 from './editor_controller';
import c78 from './enrollment_extenstion_selection_controller';
import c79 from './export_form_controller';
import c80 from './extra_curricular_courses_form_controller';
import c81 from './faculty_selection_controller';
import c82 from './file_input_controller';
import c83 from './file_upload_controller';
import c84 from './flatpickr_controller';
import c85 from './form_prevent_default_controller';
import c86 from './form_submit_controller';
import c87 from './frame_switcher_controller';
import c88 from './get_form_controller';
import c89 from './healthcheck_controller';
import c90 from './hello_controller';
import c91 from './hidden_submit_controller';
import c92 from './keep_checkbox_controller';
import c93 from './keep_form_controller';
import c94 from './login_logs_controller';
import c95 from './media_completion_test_corrections_controller';
import c96 from './media_completion_test_corrections_list_item_form_controller';
import c97 from './media_teaching_applications_status_controller';
import c98 from './media_teaching_courses_form_controller';
import c99 from './media_teachings_controller';
import c100 from './merchandise_purchase_quantity_controller';
import c101 from './merchandise_purchase_summary_controller';
import c102 from './merchandise_purchase_text_controller';
import c103 from './multistyle_dateselect_controller';
import c104 from './no_paste_controller';
import c105 from './popup_modal_controller';
import c106 from './postal_code_api_controller';
import c107 from './prevent_turbo_scroll_controller';
import c108 from './print_controller';
import c109 from './purchase_applications_controller';
import c110 from './questionnaires_controller';
import c111 from './quill_controller';
import c112 from './quiz_choice_controller';
import c113 from './radio_link_switcher_controller';
import c114 from './random_password_controller';
import c115 from './reform_controller';
import c116 from './remand_modal_controller';
import c117 from './required_confirmed_button_controller';
import c118 from './resize_controller';
import c119 from './rest_time_controller';
import c120 from './row_click_controller';
import c121 from './row_link_controller';
import c122 from './row_selection_controller';
import c123 from './school_register_renewal_selection_controller';
import c124 from './schooling_applications_status_controller';
import c125 from './schooling_courses_form_controller';
import c126 from './scoring_modal_controller';
import c127 from './scroll_into_view_controller';
import c128 from './select2_controller';
import c129 from './server_time_controller';
import c130 from './session_timeout_timer_controller';
import c131 from './student_card_reissue_controller';
import c132 from './student_certificate_applications_controller';
import c133 from './student_search_terms_controller';
import c134 from './tabs_controller';
import c135 from './teaching_application_management_form_controller';
import c136 from './teaching_contents_controller';
import c137 from './test_timer_controller';
import c138 from './test_timeup_controller';
import c139 from './thesis_edit_controller';
import c140 from './thesis_theme_selection_controller';
import c141 from './tooltip_controller';
import c142 from './total_count_controller';
import c143 from './window_close_controller';
export const definitions = [
	{identifier: 'ability-test--answer', controllerConstructor: c0},
	{identifier: 'ability-test--ascertain-answer', controllerConstructor: c1},
	{identifier: 'ability-test--confirmation-button', controllerConstructor: c2},
	{identifier: 'ability-test--next-button', controllerConstructor: c3},
	{identifier: 'ability-test', controllerConstructor: c4},
	{identifier: 'additional-study-courses-form', controllerConstructor: c5},
	{identifier: 'admin--boards', controllerConstructor: c6},
	{identifier: 'admin--course-completion-test-corrections-correction-form', controllerConstructor: c7},
	{identifier: 'admin--informations-student-form', controllerConstructor: c8},
	{identifier: 'admin--media-completion-test-corrections-correction-form', controllerConstructor: c9},
	{identifier: 'admin--sc-schedules-index', controllerConstructor: c10},
	{identifier: 'admin--sc-schedules-show', controllerConstructor: c11},
	{identifier: 'admin--teaching-applications', controllerConstructor: c12},
	{identifier: 'admin--teachings--ability-test-companion-groups-form', controllerConstructor: c13},
	{identifier: 'admin--teachings--course-learning-pattern-form', controllerConstructor: c14},
	{identifier: 'admin--teachings--sections-edits--ability-test-questions-form', controllerConstructor: c15},
	{identifier: 'admin--teachings--sections-edits--ability-tests-form', controllerConstructor: c16},
	{identifier: 'admin--teachings--sections-edits--ascertain-tests-form', controllerConstructor: c17},
	{identifier: 'admin--teachings--sections-edits--media-completion-tests-form', controllerConstructor: c18},
	{identifier: 'admin--teachings--sections-edits--questionnaires-form', controllerConstructor: c19},
	{identifier: 'admin--teachings--sections-edits--report-question-form', controllerConstructor: c20},
	{identifier: 'admin--teachings--sections-edits-form', controllerConstructor: c21},
	{identifier: 'admin--teachings--sections-edits-form-name-setter', controllerConstructor: c22},
	{identifier: 'admin--teachings--settings--total-burden-rate-chargers', controllerConstructor: c23},
	{identifier: 'admin--teachings', controllerConstructor: c24},
	{identifier: 'admin--thesis', controllerConstructor: c25},
	{identifier: 'admin-boards', controllerConstructor: c26},
	{identifier: 'admin-users', controllerConstructor: c27},
	{identifier: 'anchor-link', controllerConstructor: c28},
	{identifier: 'ascertain-test--alternative-test', controllerConstructor: c29},
	{identifier: 'ascertain-test--complete-answer-test', controllerConstructor: c30},
	{identifier: 'ascertain-test--description-test', controllerConstructor: c31},
	{identifier: 'ascertain-test--no-particular-order-test', controllerConstructor: c32},
	{identifier: 'ascertain-test--self-assessment-test', controllerConstructor: c33},
	{identifier: 'ascertain-test--timer', controllerConstructor: c34},
	{identifier: 'assign-reports', controllerConstructor: c35},
	{identifier: 'assign-requests', controllerConstructor: c36},
	{identifier: 'authorings', controllerConstructor: c37},
	{identifier: 'auto-submit', controllerConstructor: c38},
	{identifier: 'auto-update', controllerConstructor: c39},
	{identifier: 'autosave', controllerConstructor: c40},
	{identifier: 'autosize', controllerConstructor: c41},
	{identifier: 'bulk-check', controllerConstructor: c42},
	{identifier: 'cache-height', controllerConstructor: c43},
	{identifier: 'certificate-application-summary', controllerConstructor: c44},
	{identifier: 'change-check-condition', controllerConstructor: c45},
	{identifier: 'change-questions', controllerConstructor: c46},
	{identifier: 'character-count-for-one-editor', controllerConstructor: c47},
	{identifier: 'checkboxes', controllerConstructor: c48},
	{identifier: 'combined-purchase-applications', controllerConstructor: c49},
	{identifier: 'combined-school-course-completion-test-applications', controllerConstructor: c50},
	{identifier: 'combined-schools--additional-studying-application', controllerConstructor: c51},
	{identifier: 'combined-schools--certificate-application', controllerConstructor: c52},
	{identifier: 'combined-schools--certificate-application-summary', controllerConstructor: c53},
	{identifier: 'combined-schools--certificate-applications-certificate-type', controllerConstructor: c54},
	{identifier: 'combined-schools--certificate-type-of-student-card', controllerConstructor: c55},
	{identifier: 'combined-schools--certificate-types-selection', controllerConstructor: c56},
	{identifier: 'combined-schools--english-name', controllerConstructor: c57},
	{identifier: 'combined-schools--reason-kind', controllerConstructor: c58},
	{identifier: 'combined-schools--school-register-renewal-application', controllerConstructor: c59},
	{identifier: 'combined-schools--teacher--extra-curricular-applications-course-form', controllerConstructor: c60},
	{identifier: 'combined-schools--teacher--media-teaching-applications-course-form', controllerConstructor: c61},
	{identifier: 'combined-schools--teacher--report-submissions-form', controllerConstructor: c62},
	{identifier: 'combined-schools--teacher--schooling-applications-course-form', controllerConstructor: c63},
	{identifier: 'commentary-modal', controllerConstructor: c64},
	{identifier: 'confirm', controllerConstructor: c65},
	{identifier: 'course-completion-test-corrections', controllerConstructor: c66},
	{identifier: 'course-completion-test-corrections-list-item-form', controllerConstructor: c67},
	{identifier: 'course-completion-test-waiting-timer', controllerConstructor: c68},
	{identifier: 'course-informations', controllerConstructor: c69},
	{identifier: 'current-time', controllerConstructor: c70},
	{identifier: 'demo--report-file-input', controllerConstructor: c71},
	{identifier: 'demo--report-form', controllerConstructor: c72},
	{identifier: 'demo--test-answer-form', controllerConstructor: c73},
	{identifier: 'display-student-info', controllerConstructor: c74},
	{identifier: 'display-teaching-info', controllerConstructor: c75},
	{identifier: 'document', controllerConstructor: c76},
	{identifier: 'editor', controllerConstructor: c77},
	{identifier: 'enrollment-extenstion-selection', controllerConstructor: c78},
	{identifier: 'export-form', controllerConstructor: c79},
	{identifier: 'extra-curricular-courses-form', controllerConstructor: c80},
	{identifier: 'faculty-selection', controllerConstructor: c81},
	{identifier: 'file-input', controllerConstructor: c82},
	{identifier: 'file-upload', controllerConstructor: c83},
	{identifier: 'flatpickr', controllerConstructor: c84},
	{identifier: 'form-prevent-default', controllerConstructor: c85},
	{identifier: 'form-submit', controllerConstructor: c86},
	{identifier: 'frame-switcher', controllerConstructor: c87},
	{identifier: 'get-form', controllerConstructor: c88},
	{identifier: 'healthcheck', controllerConstructor: c89},
	{identifier: 'hello', controllerConstructor: c90},
	{identifier: 'hidden-submit', controllerConstructor: c91},
	{identifier: 'keep-checkbox', controllerConstructor: c92},
	{identifier: 'keep-form', controllerConstructor: c93},
	{identifier: 'login-logs', controllerConstructor: c94},
	{identifier: 'media-completion-test-corrections', controllerConstructor: c95},
	{identifier: 'media-completion-test-corrections-list-item-form', controllerConstructor: c96},
	{identifier: 'media-teaching-applications-status', controllerConstructor: c97},
	{identifier: 'media-teaching-courses-form', controllerConstructor: c98},
	{identifier: 'media-teachings', controllerConstructor: c99},
	{identifier: 'merchandise-purchase-quantity', controllerConstructor: c100},
	{identifier: 'merchandise-purchase-summary', controllerConstructor: c101},
	{identifier: 'merchandise-purchase-text', controllerConstructor: c102},
	{identifier: 'multistyle-dateselect', controllerConstructor: c103},
	{identifier: 'no-paste', controllerConstructor: c104},
	{identifier: 'popup-modal', controllerConstructor: c105},
	{identifier: 'postal-code-api', controllerConstructor: c106},
	{identifier: 'prevent-turbo-scroll', controllerConstructor: c107},
	{identifier: 'print', controllerConstructor: c108},
	{identifier: 'purchase-applications', controllerConstructor: c109},
	{identifier: 'questionnaires', controllerConstructor: c110},
	{identifier: 'quill', controllerConstructor: c111},
	{identifier: 'quiz-choice', controllerConstructor: c112},
	{identifier: 'radio-link-switcher', controllerConstructor: c113},
	{identifier: 'random-password', controllerConstructor: c114},
	{identifier: 'reform', controllerConstructor: c115},
	{identifier: 'remand-modal', controllerConstructor: c116},
	{identifier: 'required-confirmed-button', controllerConstructor: c117},
	{identifier: 'resize', controllerConstructor: c118},
	{identifier: 'rest-time', controllerConstructor: c119},
	{identifier: 'row-click', controllerConstructor: c120},
	{identifier: 'row-link', controllerConstructor: c121},
	{identifier: 'row-selection', controllerConstructor: c122},
	{identifier: 'school-register-renewal-selection', controllerConstructor: c123},
	{identifier: 'schooling-applications-status', controllerConstructor: c124},
	{identifier: 'schooling-courses-form', controllerConstructor: c125},
	{identifier: 'scoring-modal', controllerConstructor: c126},
	{identifier: 'scroll-into-view', controllerConstructor: c127},
	{identifier: 'select2', controllerConstructor: c128},
	{identifier: 'server-time', controllerConstructor: c129},
	{identifier: 'session-timeout-timer', controllerConstructor: c130},
	{identifier: 'student-card-reissue', controllerConstructor: c131},
	{identifier: 'student-certificate-applications', controllerConstructor: c132},
	{identifier: 'student-search-terms', controllerConstructor: c133},
	{identifier: 'tabs', controllerConstructor: c134},
	{identifier: 'teaching-application-management-form', controllerConstructor: c135},
	{identifier: 'teaching-contents', controllerConstructor: c136},
	{identifier: 'test-timer', controllerConstructor: c137},
	{identifier: 'test-timeup', controllerConstructor: c138},
	{identifier: 'thesis-edit', controllerConstructor: c139},
	{identifier: 'thesis-theme-selection', controllerConstructor: c140},
	{identifier: 'tooltip', controllerConstructor: c141},
	{identifier: 'total-count', controllerConstructor: c142},
	{identifier: 'window-close', controllerConstructor: c143},
];
